import { selectTotalArea } from '../../../../selectors';

export const makeSelectTotalArea = (): typeof selectTotalArea =>
    selectTotalArea;
